import * as React from 'react';
import GamePageLayout from '../../components/GamePageLayout';
import GameNavbar from "../../components/GameNavbar";
import GameHeader from "../../components/GameHeader";
import appService from '../../Service'
import './styles.css'
import {useEffect, useState} from "react";
import {confirmDialog, showErrorDialog, showSuccessDialog , showCustomDialog,closeDialog,Button,showLoading,Util} from "baziigram";
import {navigate} from 'gatsby'
import {dictionary} from "../../constants"
import {prizesDictionary} from "../../constants/prizes"
import {UpdateUser} from "../../Util/user"
const AwardsPage = () => {

    React.useEffect(()=>{
        loadAwards()

    },[])



    const [awards,setAwards] = useState(null)
    const [expandedIndex,setExpandedIndex] = useState(null)
    const [serverError,setServerError] = useState(null)
    const [language , setLanguage] = React.useState(null)
    const [className , setClassName] = React.useState("rtl text-right")

    React.useEffect(()=>{
    setLanguage(Util.getLanguage())
    if(language == "en")
    setClassName("ltr text-left")
    },[language])

    const loadAwards=()=>{
        setServerError(null)
        appService.GetAwardsList().then(res=>{
           setAwards(res.list)
             }).catch(err=>{
            setServerError(dictionary.retryText[language])
        })
    }


    const scrollToAwards = ()=>{
        document.getElementById('awards').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

  const  showConfirmDialog=(item,option)=>{
         let actions = [
             { title: dictionary.no[language], className: "baziigram-secondary-btn", action: null },
             {
                 title: dictionary.yes[language],
                 className: "baziigram-ok-btn",
                 action: () => confirmBuy(item , option.description),
             },
         ];
         confirmDialog(
             ` ${option.requiredCoins}  ${prizesDictionary.phoecoinPaymentTxt[language]} `,
             actions
         );
     }

     const confirmBuy=(business , description)=>{
         showLoading(true);
         appService
             .GetPrize(business.id , description)
             .then(res => {
                UpdateUser({coins:res.userCoins})
                 showReceiptDialog(res.award,business)

             })
             .catch(err => {
                 showErrorDialog(err.message || err);
             })
             .finally(res => {
                 showLoading(false);
             });
     }

const goToPage=(link)=>{
closeDialog()
if(link.indexOf("http")>-1)
navigate("/WebView",{state:{url:link}})

else
window.open(link)

}


const openItem=(index)=>{
if(expandedIndex==index)
setExpandedIndex(null)

else
setExpandedIndex(index)
}

const needMarquee=(text)=>{
const vw = Math.min(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) , 900)

if (text.length*8 > Math.floor((vw-40)*0.55))
      return (
        <marquee behavior="scroll" scrollamount="2" direction="right">
          {text}
        </marquee>
      )
 return text
}

const showReceiptDialog=(prize,business)=>{

let body = <div className="d-flex flex-column justify-content-between my-2  align-items-center" >
            <img style={{display:"block"}} width={"60px"} height={"60px"} className={"mx-auto"}
                        src={business.logo}/>
            <div class={`${className} text-center my-1`}>{prize.category == prizesDictionary.charge[language] ? prizesDictionary.pinCharge[language] : prizesDictionary.discountCode[language]}  {prize.code}</div>
           {prize.expirationDate && prize.expirationDate!="" && <div class={`${className} text-center my-1`}>{prizesDictionary.expDate[language]}:   {prize.expirationDate}</div>}
           <div class={`${className} text-center my-1`}> {prize.description}</div>
           {prize.link && prize.link!="" && <Button onClick={()=>goToPage(prize.link)} className="full-width-btn my-2" title={prizesDictionary.purchase[language]}/>}
           </div>

     showCustomDialog(body)

}

    return (
        <GamePageLayout type={"AWARDS"}>
            <GameNavbar />
            <div className={"rtl"}>
                <GameHeader class={"d-flex  home-header"} type={"AWARDS"}>

                        <div className={" my-2 text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                            <div dangerouslySetInnerHTML={{__html: prizesDictionary.header[language]}} />
                            <Button onClick={scrollToAwards} title={prizesDictionary.see[language]}></Button>

                        </div>

                </GameHeader>


                <div id={"awards"} className='main_container'>

                    {awards==null && serverError==null && <div
                        className={`baziigram-spinner mt-5 spinner-border text-light m-auto`}
                        role="status"
                    ></div>}
                    {serverError && <div className={"text-center text-warning "}>
                        {serverError}
                        <Button onClick={loadAwards} className={"mt-3"} title={dictionary.retry[language]}/>
                    </div>}
                    {awards != null && awards.length==0 &&  serverError==null && <div className="text-center my-3">
                    {dictionary.noAward[language]}
                    </div>}
                    {awards != null && awards.length>0 &&  serverError==null &&
                          <div className={`${className} grid-container mt-3`}>
                             { awards && awards.map((award,index)=>{
                              return <div className="my-2 award-item" >
                                 <div className="d-flex flex-row justify-content-between  align-items-center">
                                  <div className="d-flex flex-row justify-content-start  align-items-center">
                                  <img  className={"business-logo mx-2"}
                                 src={award.logo}/>
                                   <h3 className={className}>{award.name}</h3>
                                   </div>
                                   <button className="arrow-btn">
                                 <div onClick={()=>openItem(index)} className={`arrow ${expandedIndex==index? "up" :"down"}`}></div>
                                 </button>
                                 </div>
                        {expandedIndex==index && <div className="d-flex flex-column justify-content-start mr-2">
                          {award.options.map(option=>{
                          return <div className="d-flex flex-column justify-content-start mr-1">
                          <div className="d-flex flex-row justify-content-between ">
                          <div style={{maxWidth:"65%"}} className={`${className} my-2 `}>
                           {needMarquee(option.description)}
                          </div>
                          <div className={`${className} my-2 `}>
                          <span >{option.requiredCoins}</span>
                          <img className="mx-2" src={"/images/icons/coin2.png"} width={"22px"}/>
                          </div>

                          </div>
                           <Button onClick={()=>showConfirmDialog(award,option)}  className="full-width-btn  my-2 mt-3" title={prizesDictionary.get[language]}/>

                          </div>
                          })}
                          </div>
                          }
                        </div>
                          })
                                }

                        </div>
                    }

                </div>

            </div>

        </GamePageLayout>
    )
}

export default AwardsPage;
